import { render, staticRenderFns } from "./LayoutHorizontalCore.vue?vue&type=template&id=ebc7e2ce"
import script from "./LayoutHorizontalCore.vue?vue&type=script&lang=js"
export * from "./LayoutHorizontalCore.vue?vue&type=script&lang=js"
import style0 from "./LayoutHorizontalCore.vue?vue&type=style&index=0&id=ebc7e2ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports